import { Manufacturer } from 'src/types/manufacturer';
import axios from 'src/utils/axios';

class ManufacturerApi {
    async find(params: any = {}): Promise<Manufacturer[]> {
        return new Promise((resolve, reject) =>
            axios({ method: 'GET', url: '/manufacturers', params })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async count(params: any = {}): Promise<number> {
        return new Promise((resolve, reject) =>
            axios({ method: 'GET', url: '/manufacturers', params: { ...params, pageSize: 1 } })
                .then((response) => {
                    resolve(Number(response.headers.totalcount));
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async findById(ID: string, params: any = {}): Promise<Manufacturer> {
        if (!ID) return null;
        return new Promise((resolve, reject) =>
            axios({ method: 'GET', url: '/manufacturers/' + ID, params })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async getHistory(ID: string, params: any = {}): Promise<Manufacturer[]> {
        return new Promise((resolve, reject) =>
            axios({ method: 'GET', url: '/manufacturers/' + ID + '/history', params })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async getStock(ID: string, start: Date, end: Date): Promise<any> {
        return new Promise((resolve, reject) =>
            axios({
                method: 'GET',
                url: '/manufacturers/' + ID + '/stock',
                params: { start: start.toISOString(), end: end.toISOString() },
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async getUse(
        ID: string,
        firstFrame: { start: Date; end: Date },
        secondFrame: { start: Date; end: Date }
    ): Promise<any> {
        return new Promise((resolve, reject) =>
            axios({
                method: 'GET',
                url: '/manufacturers/' + ID + '/use',
                params: {
                    firstFrameStart: firstFrame.start.toISOString(),
                    firstFrameEnd: firstFrame.end.toISOString(),
                    secondFrameStart: secondFrame.start.toISOString(),
                    secondFrameEnd: secondFrame.end.toISOString(),
                },
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async create(data: Manufacturer): Promise<Manufacturer> {
        return new Promise((resolve, reject) =>
            axios({
                method: 'POST',
                url: '/manufacturers',
                data,
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async update(ID: string, data: Manufacturer): Promise<Manufacturer> {
        return new Promise((resolve, reject) =>
            axios({
                method: 'PUT',
                url: '/manufacturers/' + ID,
                data,
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }

    async delete(ID: string): Promise<Manufacturer> {
        return new Promise((resolve, reject) =>
            axios({
                method: 'DELETE',
                url: '/manufacturers/' + ID,
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('[Manufacturers Api]: ', error.response ? error.response.data : error);
                    reject(error.response ? error.response.data : error);
                })
        );
    }
}

export const manufacturerApi = new ManufacturerApi();
